import Fuse from 'fuse.js';

import museaFlanders from '@App/components/Map/data/musea-municipalities.json';

function getLocalizedMuseumName(feature, lang = 'nl') {
  const { properties = {} } = feature;
  const name = properties.name || properties.municipality || '';
  const translatedName = properties[`name:${lang}`];

  if (translatedName) return translatedName;

  const names = name.split(/\s+-\s+/);
  const languageIndex = {
    de: 0,
    en: 2,
    fr: 1,
    nl: 0,
  };
  const selectedName = names[languageIndex[lang] ?? 0] || names[0];

  return selectedName || name;
}

const museaSearcher = new Fuse(museaFlanders.features, {
  keys: [
    { name: 'properties.name', weight: 2 },
    { name: 'properties["name:en"]', weight: 2 },
    { name: 'properties.municipality', weight: 1.5 },
    { name: 'properties.description', weight: 1.5 },
    { name: 'properties["addr:street"]', weight: 1 },
    { name: 'properties["addr:city"]', weight: 1 },
    { name: 'properties["addr:postcode"]', weight: 1 },
    { name: 'properties.tourism', weight: 0.5 },
    { name: 'properties.historic', weight: 0.5 },
  ],
  threshold: 0.4,
  distance: 100,
  minMatchCharLength: 2,
  includeScore: true,
  useExtendedSearch: true,
});

function searchMuseums(query, limit = 20) {
  if (!query.trim()) {
    return museaFlanders.features.slice(0, limit).map(item => ({ item }));
  }

  return museaSearcher.search(query, { limit });
}

export { getLocalizedMuseumName, searchMuseums };
